const InvitationTypes = Object.freeze({
  ADVISOR_TO_CLIENT: 1,
  CLIENT_TO_COLLABORATOR: 2,
});

export default InvitationTypes;
